import { createContextHook } from '@/utils';
import { CollectionContext } from './CollectionContext';

export const useCollection = createContextHook(CollectionContext);
